import React from 'react'

export const Spiner = () => {
  return (
    <div>
        <div className='spinner'>
            
        </div>
        <p>lodding</p>
    </div>
  )
}
